import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import Img1 from 'assets/2020TRbadge-lg.png';
import Img2 from 'assets/Four-Star-Rating-Badge-Full-Color-1024x1024.png';
import Img3 from 'assets/gximage2.png';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-100 pt-16 pb-10 px-6 md:px-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
        {/* Column 1: ISPU Office */}
        <div>
          <h3 className="text-xl font-bold mb-2">ISPUganda Office</h3>
          <div className="w-16 h-1 bg-green-400 mb-4" />
          <p className="flex items-start mb-2">
            <FaMapMarkerAlt className="mr-2 mt-1 text-green-400" />
            Kampala, Uganda
          </p>
          <p className="flex items-center mt-2">
            <FaPhoneAlt className="mr-2 text-green-400" /> (800) 555-1234
          </p>
          <div className="flex flex-row items-center space-x-2">
            <img src={Img3} alt="GuideStar" className="w-32 mt-4" />
            <img src={Img1} alt="2020 Transparency Badge" className="w-32 mt-4" />
          </div>
          <img src={Img2} alt="Four Star Rating Badge" className="w-32 mt-4" />
        </div>

        {/* Column 2: Make a Contribution */}
        <div>
          <div className="">
            <h3 className="text-xl font-bold mb-2">Make a Contribution</h3>
            <div className="w-16 h-1 bg-green-400 mb-4" />
            <p>
              If you'd like to support ISPU you can make a donation online, contact us directly at{' '}
              <span className="font-semibold">(800) 920-4778</span>, or mail a check to our office.
            </p>
          </div>
          <div className="">
            <h3 className="text-xl font-bold mb-2">Privacy Policy & Disclaimer</h3>
            <div className="w-16 h-1 bg-green-400 mb-4" />
            <a href="#" className="text-green-400 hover:underline">
              Privacy Policy
            </a>
            <p>
              ISPU collaborates with a variety of organizations, scholars, and communities in
              pursuit of our mission to provide objective research and education about American
              Muslims to support well-informed dialogue and decision-making. We aim to work with and
              learn from others in this space, while we maintain our independence as a research
              institution. ISPU staff and scholars are solely responsible for their conclusions, and
              the opinions expressed are that of the author, and do not necessarily reflect the
              views of ISPU.
            </p>
            <a href="#" className="text-green-400 hover:underline">
              Contact Us
            </a>
          </div>
        </div>

        {/* Column 3: Newsletter Subscription */}
        <div>
          <h3 className="text-xl font-bold mb-2">Subscribe to Our Newsletter</h3>
          <div className="w-16 h-1 bg-green-400 mb-4" />
          <form className="flex flex-col gap-4">
            <div className="flex flex-row items-center space-x-2">
              <input
                type="text"
                placeholder="First Name"
                className="p-3 rounded-md w-full bg-gray-700 text-gray-100 focus:outline-none"
              />
              <input
                type="text"
                placeholder="Last Name"
                className="p-3 rounded-md w-full bg-gray-700 text-gray-100 focus:outline-none"
              />
            </div>
            <input
              type="email"
              placeholder="Enter your email"
              className="p-3 rounded-md bg-gray-700 text-gray-100 focus:outline-none"
            />
            <input
              type="text"
              placeholder="City"
              className="p-3 rounded-md bg-gray-700 text-gray-100 focus:outline-none"
            />
            <input
              type="text"
              placeholder="State"
              className="p-3 rounded-md bg-gray-700 text-gray-100 focus:outline-none"
            />
            <button
              type="submit"
              className="bg-green-400 text-gray-100 w-fit px-3 font-semibold py-2 rounded-md hover:bg-green-500 transition"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>

      {/* Divider */}
      <hr className="border-gray-700 mb-6" />

      {/* Footer Bottom */}
      <div className="text-center text-sm text-gray-400">
        <p>© Institute for Social Policy and Understanding</p>
        <p className="mt-1">
          Website Developed By <span className="text-white font-medium">Ashita Creatives</span>
        </p>
      </div>
    </footer>
  );
};
